<template>
    <v-container fluid>
      <v-card>
        <v-toolbar color="secondary" flat dense>
          <v-toolbar-title>Owner Z Report</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <v-row class="subtitle-2 text--primary">
            <v-col cols="5">
              <div style="font-weight: bold; font-size: 18px">System Generated</div>
  
              <!-- start of sales -->
              <v-row class="mt-2">
                <v-col cols="12">
                  <div style="font-weight: bold; font-size: 14px">Sales Summary</div>
                  <v-simple-table dense class="mt-2">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td>Total Sales</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalSales && zReport.TotalSales.toLocaleString() }}</td>
                        </tr>
                        <tr>
                          <td>Total Payments</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalSalesPayment && zReport.TotalSalesPayment.toLocaleString() }}</td>
                        </tr>
  
                        <tr>
                          <td>Credit Sales</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalCreditSales && zReport.TotalCreditSales.toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <!-- end of sales -->
  
              <!-- start of sale payments summary -->
              <v-row class="mt-2">
                <v-col cols="12">
                  <div style="font-weight: bold; font-size: 14px">Payments Summary</div>
                  <v-simple-table
                    dense
                    class="mt-2"
                    v-if="zReport.SalesPayments && zReport.SalesPayments.length > 0"
                  >
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="(item, index) in zReport.SalesPayments" :key="index">
                          <td>{{ item.oact.Name }}</td>
                          <td
                            class="text-right"
                          >{{item.TotalModeSum && item.TotalModeSum.toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <!-- end of sales -->
  
              <!-- start of purchases -->
              <v-row class="mt-2">
                <v-col cols="12">
                  <div style="font-weight: bold; font-size: 14px">Purchases Summary</div>
                  <v-simple-table dense class="mt-2">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td>Total Purchases</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalPurchases && zReport.TotalPurchases.toLocaleString() }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <!-- end of purchases -->
  
              <!-- start of cash transactions summary -->
              <v-row class="mt-2">
                <v-col cols="12">
                  <div style="font-weight: bold; font-size: 14px">Cash Transactions Summary</div>
                  <v-simple-table dense class="mt-2">
                    <template v-slot:default>
                      <tbody>
                        <tr>
                          <td>Starting Float</td>
                          <td
                            class="text-right"
                          >{{ zReport.StartingFloat && zReport.StartingFloat.toLocaleString() }}</td>
                        </tr>
                        <tr>
                          <td>Cash Payments (Sales)</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalSalesCashPayment && zReport.TotalSalesCashPayment.toLocaleString() }}</td>
                        </tr>
  
                        <tr>
                          <td>Cash Payments (Purchases)</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalPurchasesCashPayment && zReport.TotalPurchasesCashPayment.toLocaleString() }}</td>
                        </tr>
  
                        <tr>
                          <td>Cash Expenses</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalCashExpenses && zReport.TotalCashExpenses.toLocaleString() }}</td>
                        </tr>
  
                        <tr>
                          <td>Cash Transfers</td>
                          <td
                            class="text-right"
                          >{{ zReport.TotalCashTransfers && zReport.TotalCashTransfers.toLocaleString() }}</td>
                        </tr>
  
  
                        <tr>
                          <td>Cash At Hand</td>
                          <td class="text-right">
                            <span
                              style="color: red"
                            >{{ zReport.CashAtHand && zReport.CashAtHand.toLocaleString() }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-col>
              </v-row>
              <!-- end of sales -->
            </v-col>
  
            <v-col cols="6">
             <div style="">
              <v-row>
                <div
                  class="mt-2 ml-3 float-right"
                  style="font-size: 20px; font-weight: bold"
                >
                <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="date"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker
                  @change="getZReport"
                  v-model="date"
                  @input="menu1 = false"
                ></v-date-picker>
              </v-menu>
                </div>
              </v-row>
  
              <v-row class="subtitle-2 text--primary">
                <v-col cols="12">
                  <v-data-table dense :mobile-breakpoint="0" :headers="closingHeaders" :items="closingData">
                    <template v-slot:item.name="{ item }">
                      <span
                        style="font-size: 14px"
                      >{{ item.denomination && item.denomination.currency_value.toLocaleString() }}</span>
                    </template>
                    <template v-slot:item.amount="{ item }">
                      <span style="font-size: 14px">{{ item.number}}</span>
                    </template>
                    <template v-slot:item.totals="{ item }">
                      <span
                        style="font-size: 14px"
                      >{{ (item.number * item.denomination.currency_value).toLocaleString() }}</span>
                    </template>
                  </v-data-table>
  
                  <div
                    style="font-size: 20px; font-weight: bold"
                  ></div>
                </v-col>
              </v-row>
             </div>
            </v-col>
          </v-row>
  
          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <div> Manual Total: Total Closing: {{ zReport.TotalClosing && zReport.TotalClosing.toLocaleString() }}</div>
                <div>Variance: {{ (zReport.CashAtHand - zReport.TotalClosing).toLocaleString() }}</div>
            </v-col>
          </v-row>
  
          <snackbar ref="snackbar"></snackbar>
        </v-card-text>
      </v-card>
    </v-container>
  </template>
    
    <script>
  export default {
    data: () => ({
      search: "",
      zReport: {},
      TotalClosing: 0,
      closingData: [],
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      headers: [
        { text: "Category", value: "vpm1.Name" },
        { text: "Amount", value: "Amount" },
        { text: "Account", value: "account.Name" },
        { text: "Description", value: "Description" },
        { text: "Date", value: "DocDate" }
      ],
      closingHeaders: [
        { text: "Title", value: "name" },
        { text: "Amount", value: "amount" },
        { text: "Total", value: "totals" }
      ],
      expenses: [],
      TotalExpenses: null
    }),
    methods: {
      setDate(date) {
        this.date = date;
      },
      getZReport() {
        let data = {};
        data.date = this.date;
        const self = this;
        const url = `/z-report`;
        this.$store
          .dispatch("post", { url, data })
          .then(res => {
            if (res.ResultCode == 1200) {
              self.loader = false;
              self.zReport = res.ResponseData;
              self.closingData = res.ResponseData.Accounts;
            } else {
              self.loader = false;
              this.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch(err => {
            this.$refs.snackbar.show(err, "red");
          });
      }
    },
    created() {
      this.getZReport();
    }
  };
  </script>